import { ExpireModel, TIME_UNITS } from 'src/app/domains/sales/activation-link/models/activation-link.model';
import { SetupFee, SetupFeeInternalId } from '../models/activate-link.model';

export const EXPIRES_TIME_LIST: ExpireModel[] = [
  {
    value: 24,
    unit: TIME_UNITS.hours
  },
  {
    value: 48,
    unit: TIME_UNITS.hours
  },
  {
    value: 7,
    unit: TIME_UNITS.days
  }
];

export const DISCOUNT_AMOUNT_LIST: number[] = [5, 10, 15, 20, 25];

export const DISCOUNT_DURATION_LIST: ExpireModel[] = [
  { value: -1, unit: TIME_UNITS.none },
  ...calculateCouponDuration()
]

function calculateCouponDuration() {
  let duration: ExpireModel[] = [];
  for(let i = 1; i < 25; i++) {
    duration.push({value: i, unit: TIME_UNITS.months});
    i++
  }
  return duration;
}

export const SETUP_FEE_RS_ID = 'voxloud_setup_charge-v1';

export const REQUIRED_ADDONS: string[] = [
  'channel',
  'phone_number'
]

export const SETUP_FEES: SetupFee[] = [
  {
    id: SetupFeeInternalId.None,
    name: 'None',
    amount: 0,
    currency: '€',
    isEditable: false
  },
  {
    id: SetupFeeInternalId.Priority,
    name: 'Priority',
    amount: 499,
    currency: '€',
    isEditable: false
  },
    {
    id: SetupFeeInternalId.Accelerator,
    name: 'Accelerator',
    amount: 4760,
    currency: '€',
    isEditable: true
  },
];